import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brand-zeit', 'BrandZeit', [["path",{"d":"M3 20h18l-9 -16z","key":"svg-0"}]]);